module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/385aa4b73a425883b4f9e91501a52299.svg";